if (!customElements.get('maison-comparison')) {
  customElements.define('maison-comparison', class extends HTMLElement {
    connectedCallback() {
      if (this.onComparisonClick) return;
      this.onComparisonClick = (event) => {
        const button = event.target.closest('[data-competitor-button]');
        if (!button || !this.contains(button)) return;
        this.dataset.competitor = button.dataset.competitorButton;
        this.querySelectorAll('[data-competitor-button]').forEach((tab) => {
          tab.setAttribute('aria-pressed', String(tab === button));
        });
      };
      this.addEventListener('click', this.onComparisonClick);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onComparisonClick);
      this.onComparisonClick = null;
    }
  });
}
